// A reply can finish while the user is typing elsewhere in the composer, such as in the caption; the chat never takes the cursor from there.
export const canReturnFocusToChat = (chat: Element | null, active: Element | null): boolean =>
  !active || active === active.ownerDocument.body || !!chat?.contains(active);
